// src/views/kiddo-games/letters/components/ImageChoice.tsx
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

interface ImageChoiceProps {
  image: string;
  isWrong: boolean;
  isSelected?: boolean;
  onClick: () => void;
}

export const ImageChoice: FC<ImageChoiceProps> = memo(({
  image, isWrong, isSelected, onClick,
}) => {
  const { t } = useTranslation();
  const className = `image-choice${isWrong ? ' image-choice--wrong' : ''}${isSelected ? ' image-choice--correct' : ''}`;

  return (
    <div
      className={className}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <img src={image} alt={t('games:labels.choose')} />
    </div>
  );
});
